import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddEthnicityFailure,
  AddEthnicitySuccess,
  EditEthnicityFailure,
  EditEthnicitySuccess,
} from '../../Redux/Actions/EthnicityAction';
import { ADD_ETHNICITY, EDIT_ETHNICITY } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddEthnicityEpic = action$ =>
  action$.pipe(
    ofType(ADD_ETHNICITY),
    switchMap(action =>
      ajax.post(`${Basepath}/api/admin/addEthnicity`, action.payload).pipe(
        mergeMap(response => {
          if (response.response.statusCode === 200) {
            history.push(routeRules.ethnicityManagement, toast.success(response.response.message));
            return of(AddEthnicitySuccess(response.response));
          } else if (response.response.statusCode == 401) {
            clearSession(response.response.message);
          } else {
            console.log(response.response);
            return of(AddEthnicityFailure(response.response));
          }
        }),
      ),
    ),
  );

export const EditEthnicityEpic = action$ =>
  action$.pipe(
    ofType(EDIT_ETHNICITY),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editEthnicity`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditEthnicitySuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditEthnicityFailure(response.response));
            }
          }),
        ),
    ),
  );
